import React, { useEffect, useMemo, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import Loader from "../../../Loader/Loader";
import downArrow from "../../../../Assets/Images/Header/downArrow.svg";

const PricingModel = ({ closeModal, data, para, marketsegment, ratecode="" }) => {
    const [listData, setListData] = useState([]); // hierarchical data
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(new Set());
    const GetRoomData = async (data, para) => {
        setLoading(true);
        let wd = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.DYNAMIC_PRICING.SNP_PRICING_GRID_DETAIL,
                body: {
                    asofdate: para?.asOfDate,
                    propertycode: para?.propertyCode,
                    clicked_staydate: data?.StayDate,
                    clicked_slab: data?.occupancy_slab === "OCCUPANCY(%)" ? "" : data?.occupancy_slab,
                    marketsegment: marketsegment ? marketsegment : "",
                    ratecode: ratecode ? ratecode : ""
                },
            },
            false
        );
        let wd_response = apiResponse(false, wd);
        if (wd_response?.isValidate) {
            const hierarchy = buildHierarchy(wd_response.data.data);
            setListData(hierarchy);
        } else {
            setListData([]);
        }
        setLoading(false);
    };

    const buildHierarchy = (data) => {
        const map = {};
        data.forEach((item) => {
            if (item?.marketsegment !== null) {
                const {
                    marketsegment,
                    ratecode,
                    company,
                    guestname,
                    roomnight = 0,
                    rate = 0,
                    leadtime_days = 0,
                    bookingdate,
                    compset_avg_rate = 0,
                    bar_rate = 0,
                } = item;

                if (!map[marketsegment]) {
                    map[marketsegment] = { label: marketsegment, children: [] };
                }
                const ms = map[marketsegment];

                let ratecodeNode = ms.children.find((x) => x.label === ratecode);
                if (!ratecodeNode) {
                    ratecodeNode = { label: ratecode, children: [] };
                    ms.children.push(ratecodeNode);
                }

                let companyNode = ratecodeNode.children.find(
                    (x) => x.label === company
                );
                if (!companyNode) {
                    companyNode = { label: company, children: [] };
                    ratecodeNode.children.push(companyNode);
                }

                companyNode.children.push({
                    label: guestname,
                    roomnight: Number(roomnight),
                    rate: Number(rate),
                    leadtime_days: Number(leadtime_days),
                    compset_avg_rate: Number(compset_avg_rate),
                    bar_rate: Number(bar_rate),
                    bookingdate,
                });
            }
        });

        // compute aggregate values for each level
        const computeAggregates = (node) => {
            if (!node.children || node.children.length === 0) {
                node.total_roomnight = node.roomnight || 0;
                node.avg_rate = node.rate || 0;
                node.avg_leadtime = node.leadtime_days || 0;
                node.avg_compset_avg_rate = node.compset_avg_rate || 0;

                node.avg_bar_rate = node.bar_rate || 0;

                node.count = 1;
                return node;
            }

            let totalRoom = 0;
            let totalRate = 0;
            let totalLead = 0;
            let totalcompset_avg_rate = 0;
            let totalbar_rate = 0;



            let count = 0;

            node.children.forEach((child) => {
                computeAggregates(child);
                totalRoom += child.total_roomnight;
                totalRate += child.avg_rate * child.count;
                totalLead += child.avg_leadtime * child.count;
                totalcompset_avg_rate += child.avg_compset_avg_rate * child.count;
                totalbar_rate += child.avg_bar_rate * child.count;
                count += child.count;
            });

            node.total_roomnight = totalRoom;
            node.avg_rate = count ? totalRate / count : 0;
            node.avg_leadtime = count ? totalLead / count : 0;
            node.avg_compset_avg_rate = count ? totalcompset_avg_rate / count : 0;
            node.avg_bar_rate = count ? totalbar_rate / count : 0;

            node.count = count;

            return node;
        };

        return Object.values(map).map((node) => computeAggregates(node));
    };

    const makeKey = (parentKey, label) => `${parentKey}|${label}`;
    const toggle = (key) => {
        setExpanded((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(key)) newSet.delete(key);
            else newSet.add(key);
            return newSet;
        });
    };

    const renderRows = (items, level = 0, parentKey = "root") =>
        items.flatMap((item) => {
            const key = `${parentKey}::${item.label}::${item?.leadtime_days}`;
            const children = Array.isArray(item.children) ? item.children : [];
            const hasChildren = children.length > 0;
            const isExpanded = expanded.has(key);

            return [
                <tr key={key} className={`level-${level}`}>
                    <td id={commonService.generateGlobalClickTrackerID("PricingModel", "td-onclick", item)} className="border_right first-col" onClick={() => toggle(key)}>
                        <span style={{ marginLeft: level * 16 }}>{item.label}</span>
                        {hasChildren && (
                            <button type="button" className="expander">
                                <img
                                    src={downArrow}
                                    alt="arrow"
                                    style={{
                                        transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                                        transition: "0.2s",
                                    }}
                                />
                            </button>
                        )}
                    </td>

                    <td className="border_right text-center">
                        {item.total_roomnight || item.roomnight || "-"}
                    </td>
                    <td className="border_right text-center">
                        {item.bookingdate
                            ? commonService.getDateInFormat(item.bookingdate)
                            : "-"}
                    </td>
                    <td className="border_right text-center">
                        {item.avg_leadtime
                            ? item.avg_leadtime.toFixed(0)
                            : item.leadtime_days
                                ? item.leadtime_days.toFixed(0)
                                : "-"}
                    </td>
                    <td className="border_right text-end">
                        {item.bar_rate
                            ? commonService.formateAmount(item.bar_rate.toFixed(0))
                            : "-"}
                    </td>

                    <td className="border_right text-end">
                        {item.avg_rate
                            ? commonService.formateAmount(item.avg_rate.toFixed(0))
                            : item.rate
                                ? commonService.formateAmount(item.rate.toFixed(0))
                                : "-"}
                    </td>
                    <td className="border_right text-end">
                        {item.avg_compset_avg_rate
                            ? commonService.formateAmount(item.avg_compset_avg_rate.toFixed(0))
                            : item.compset_avg_rate
                                ? commonService.formateAmount(item.compset_avg_rate.toFixed(0))
                                : "-"}
                    </td>
                </tr>,
                ...(isExpanded ? renderRows(children, level + 1, key) : []),
            ];
        });

    useEffect(() => {
        if (data) {
            GetRoomData(data, para);
        }
    }, [data]);
    const hierarchyData = useMemo(() => listData, [listData]);

    return (
        <div
            className={`GroupNameModalMain singleDateSummaryModalMain ToolsSingleTicketPopUpMain`}
        >
            <div className="GroupNameModalHeader">
                <div className="singleDateSummaryModalHeader">
                    <h2>
                        {" "}
                        {`${parseInt(data?.total_roomnights)} Rooms ${parseInt(
                            data?.avg_leadtime
                        )} Days ${commonService.formateAmount(parseInt(data?.avg_rate))}`}
                    </h2>
                </div>
                <button id={commonService.generateGlobalClickTrackerID("PricingModel", "button-onclick", data)} className="btn-close" onClick={closeModal}></button>
            </div>
            <div className="singleDateSummaryModalContent">
                <div className="ViewPropertySetupTable">
                    <div className="table__container">
                        <div className="stripped__table">
                            <Table className="table-with-spacing positionStaticTable dailySummaryTbl myTable">
                                <colgroup>
                                    <col style={{ width: "40%" }} />
                                    <col style={{ width: "14%" }} />
                                    <col style={{ width: "13%" }} />
                                    <col style={{ width: "13%" }} />
                                </colgroup>
                                <thead className="tbl-header-sticky">
                                    <tr className="table-main-header-tr">
                                        <th className="border_right">Market Segment</th>
                                        <th className="border_right text-center">Room Night</th>
                                        <th className="border_right text-center">Booking Date</th>
                                        <th className="border_right text-center">Lead Time Days</th>
                                        <th className="border_right text-center">Booking Time Rate</th>
                                        <th className="border_right text-center">Rate</th>
                                        <th className="border_right text-center">
                                            Compset Avg Rate
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : hierarchyData?.length ? (
                                        renderRows(hierarchyData)
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center">
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingModel;
